import { defineStore } from "pinia";
import { ref } from "vue";

export const useContextStore = defineStore("context", () => {
  const charity = ref(null);

  function setCharity(charityValue) {
    charity.value = charityValue;
  }

  return { charity, setCharity };
});
